export default {"src":"/_next/static/media/linkedin.acf729fc.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};